import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer>
            <Container>
                <div className="footer text-center text-white">
                <p>Copyright By@<a className='text-decoration-none' href="https://www.facebook.com/mdfarid.hossain.9003/" rel='noreferrer' target="_blank">Md. Farid Hossain Jibon</a> - 2021</p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;